<template>
  <div id="contact">
    <div class="contactform" ref="contactform">
      <div class="message-submitted">
        <h2>
          <span class="row">
            <span class="row-inner"> YOUR <span class="courier"> MESSAGE</span> HAS </span>
          </span>
          <span class="row">
            <span class="row-inner">
              <span class="row">BEEN RECEIVED.</span>
            </span>
          </span>
        </h2>
      </div>
      <form @submit="handleSubmit" ref="form">
        <div class="inputter">
          <label class="labeller" for="name">{{ !$french ? "Name" : "Nom" }}</label>
          <input type="text" ref="name" id="name" required />
        </div>

        <div class="inputter">
          <label class="labeller" for="email">{{ !$french ? "Email" : "Courriel" }}</label>
          <input ref="email" id="email" required />
          <!-- type="email" -->
        </div>

        <div class="inputter">
          <label class="labeller" for="message">Message</label>
          <textarea id="message" rows="10" ref="message" required aria-label="Message"></textarea>
        </div>

        <input class="submit-ghost" aria-hidden="false" tabindex="0" style="z-index: -1" id="submit" type="submit" />

        <div class="inputter" aria-hidden="true">
          <a role="button" class="submit-a">
            <label for="submit" style="height: 0; display: block">Submit</label>
            <input class="submit-ghost" id="submit" type="submit" />
            <strong class="submit"> {{ !$french ? "Submit" : "Soumettre" }} </strong>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import Email from "../smtp.js";
export default {
  name: "ContactSection",
  components: {},
  watch: {},
  data() {
    return {
      showSuccess: false,
      timeout: null,
      message: "nessage",
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      let name = this.$refs.name.value;
      let email = this.$refs.email.value;
      this.message = this.$refs.message.value;

      let data = {
        data: `
          Name: ${this.$refs.name.value}
          Email: ${this.$refs.email.value}
          Message: ${this.$refs.message.value}
          `,
      };

      const axios = require("axios");

      axios.post("https://submit-form.com/WWvZUnrFo", data).then(() => {
        this.successMessage = "Thank you! Your submission has been sent successfully";
        this.showSuccess = true;
        this.$refs.contactform.className += ` submitted`;
        this.$refs.form.reset();
        this.timeout = setTimeout(() => {
          this.showSuccess = false;
          clearTimeout(this.timeout);
        }, 5000);
      });

      //   Email.send({
      //     SecureToken : "f576814f-285b-4ce7-9ae9-1d2f35fc62ca",
      //     To : 'rebjanec@gmail.com',
      //     From : "carllective@rebj.ca",
      //     Subject : `From rebj.ca`,
      //     Body : `
      //     Name: ${name} <br/>
      //     Email: ${email} <br/>
      //     Message: ${this.message}
      //     `
      // }).then(status => {
      //   if (status === "OK") {
      //     this.showSuccess = true;
      //     this.$refs.contactform.className += ` submitted`;
      //     this.$refs.form.reset();
      //     this.timeout = setTimeout(() => {
      //       this.showSuccess = false;
      //       clearTimeout(this.timeout);
      //     }, 5000);
      //   }
      // });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles.scss";

#contact {
  position: relative;
  mix-blend-mode: difference;
}

.contactform {
  max-width: $maxwidth;
  text-align: left;
  margin: auto;
  margin: 0 auto;
  padding: 0 $desktopmargin;
  @media screen and (max-width: $mobiledown) {
    padding: 0 20px;
  }

  label {
    font-family: "Helvetica Neue";
    text-transform: uppercase;
    padding-right: 20px;
    font-size: $size-header;
    display: block;
    @media screen and (max-width: $mobiledown) {
      font-size: $size-subheader;
    }
  }
  table {
    width: 100%;
    border-spacing: 0 10px;
    td {
      @media screen and (max-width: $mobiledown) {
        display: block;
      }
    }
  }
  input,
  textarea {
    outline: none;
    width: calc(100% - 22px);
    font-family: Courier;
    padding: 20px 10px;
    background: none;
    border: 1px solid white;
    color: white;
    font-size: $size-body;
    transition: atransformll 1s $transition;
    transform: translateY(0%);
  }
  .labeller {
    display: inline-block;
    overflow: hidden;
    color: white;
    vertical-align: top;
    line-height: 1.25;
    @media screen and (min-width: 768px) {
      width: 25%;
      & ~ input,
      & ~ textarea {
        width: calc(75% - 42px);
        vertical-align: top;
        display: inline-block;
      }
    }
  }
  .inputter {
    width: 100%;
    overflow: hidden;
  }
  .submit {
    font-family: "Helvetica Neue";
    text-transform: uppercase;
    font-size: 80px;
    padding: 0;
    text-align: left;
    border: none;
    width: 100%;
    cursor: pointer;
    color: white;
  }
  .submit-ghost {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 6;
    cursor: pointer;
  }
  .submit-a {
    position: relative;
    transition: transform 1s $transition;
    transform: translateY(0%);
    font-size: 80px;

    @media screen and (min-width: 768px) {
      margin-left: calc(25% + 20px);
    }
  }
  strong {
    font-size: 80px;
    &:after {
      color: white;
    }
  }
}
.submitted {
  .inputter,
  .labeller {
    input,
    textarea,
    label,
    .submit-a {
      transform: translateY(calc(-100% - 40px));
      transition: transform 1s $transition;
    }
  }
  .message-submitted {
    color: white;

    .row {
      .row-inner {
        transition: transform 1s $transition 0.25s;
        transform: translateY(0%);
      }
    }

    .message-submitted {
      pointer-events: auto;
    }
  }
}

.message-submitted {
  pointer-events: none;
  max-width: 600px;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 4;

  h2 {
    font-size: $size-header;
    line-height: 1.15;
    margin: 0;
    text-align: center;

    span {
      font-size: $size-header;
      display: inline-block;
      line-height: 1.15;
      position: relative;
    }
    .courier {
      font-family: Courier;
      font-weight: 100;
      font-size: calc($size-header + 10px);
    }
  }

  .row {
    overflow: hidden;
    .row-inner {
      transition: transform 1s $transition 0.25s;
      transform: translateY(100%);
      display: block;
    }
  }
}
</style>
